var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ContentEditor"},[_c('div',{staticClass:"SlotEditingZone"},[_c('ce-fallback-switch'),_c('ce-editing-zone',{ref:"editing-zone",attrs:{"rows":_vm.rows,"body":_vm.body}})],1),_c('div',{staticClass:"SlotSidePanel"},[_c('ce-side-panel',{ref:"side-panel"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }